<template>
    <div class="widget tools-widget">
        <header class="widget-header">
            <h3><i class="fal fa-tools" /> Tools</h3>
        </header>
        <div class="widget-body">
            <transition
                name="fade"
                mode="out-in"
            >
                <div v-if="products" class="products">
                    <div
                        v-for="product in products"
                        :key="product.id"
                        class="product"
                    >
                        <div class="product-header">
                            <div class="product-icon">
                                <img
                                    :src="product.image_url"
                                    :alt="product.name"
                                >
                            </div>
                            <div class="product-version">
                                version {{ product.version }} (<a href="#" @click.prevent="() => onChangelogClick(product.changelog)">changelog</a>)
                            </div>
                        </div>
                        <div class="product-description">
                            <p>
                                {{ product.description }}
                                <router-link :to="{path: '/tools#' + product.wp_slug}">
                                    See more...
                                </router-link>
                            </p>
                            <a class="btn" :href="product.package_url"><i class="far fa-download" />Download WP Plugin</a>
                        </div>
                    </div>
                </div>
                <div
                    v-else
                    class="loading"
                >
                    <i class="fas fa-spinner fa-spin loader" />
                </div>
            </transition>
        </div>
        <transition
            name="fade"
            mode="out-in"
        >
            <base-changelog-modal
                v-if="showChangelog"
                @close-modal="toggleChangelogModal"
            >
                <div v-html="changelog" /><!-- eslint-disable-line vue/no-v-html -->
            </base-changelog-modal>
        </transition>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import changelogModal from '@/mixins/changelogModal';

export default {
    mixins: [changelogModal],

    /**
     * @returns {Array} Data.
     */
    data() {
        return {
            changelog: null,
        };
    },

    computed: mapState(['products']),

    methods: {
        /**
         * Chandles changelog link click.
         *
         * @param   {string} changelog Changelog content.
         * @returns {void}
         */
        onChangelogClick(changelog) {
            this.changelog = changelog;
            this.toggleChangelogModal();
        },
    },
};
</script>
